import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import { Error500Component } from './pages/error500/error500.component';
import { Error404Component } from './pages/error404/error404.component';
import { ErrorComponent } from './components/error/error.component';
import {NeoSharedModule} from '@appNeo/neoShared/neoShared.module';
import { Error404SvgComponent } from './components/error404-svg/error404-svg.component';
import { Error500SvgComponent } from './components/error500-svg/error500-svg.component';

const routesError: Routes = [
  {
    path: '404',
    component: Error404Component,
  },
  {
    path: '500',
    component: Error500Component
  },
];


@NgModule({
  declarations: [Error500Component, Error404Component, ErrorComponent, Error404SvgComponent, Error500SvgComponent],
  imports: [
    CommonModule,
    RouterModule,
    NeoSharedModule,
    RouterModule.forChild(routesError)
  ],
  exports: [
    RouterModule
  ]
})
export class ErrorModule { }
